import React, { useCallback, useEffect, useState } from "react";

import { getSearchSuggestions } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Col, MainPage, Row } from "components";

export const Suggestions = () => {
  const [loading, setLoading] = useState(true);
  const [suggestions, setSuggestions] = useState([]);
  const signal = useCancelAsyncOnUnmount()();

  const loadSuggestions = useCallback(() => {
    getSearchSuggestions({
      signal,
    })
      .then((res) => {
        setSuggestions(res.length > 0 ? res : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  useEffect(() => {
    loadSuggestions();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline={`${suggestions.length} search suggestions`}
        description={
          <>
            View all search suggestions here. Each tag is scored according the qty of times it appears in articles and searches. <b>Seeds</b> are used to ensure
            the data does not circle around the same results all the time. The tags from the most recently created articles are marked as seeds, and two are
            bumped to the top of the list for users to see.
          </>
        }
      />
      <Row>
        <Col>
          <AdminTable
            dataSource={suggestions}
            config={{
              exclude: ["articles", "community", "weightedNormalisedArticleCount", "weightedNormalisedSearchCount", "weighting"],
              actions: [],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
